
export function Banner() {
    return (
      <div className="bg-pink-400">
        <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
          <div className="flex items-center flex-wrap">
            <p className="font-medium grow text-white text-center">
            A Harry Styles inspired Wordle clone.
            </p>
          </div>
        </div>
      </div>
    )
  }